<div class="sx-help">
  <div class="sx-help__header">
    <button class="sx-help__header__close sx-button sx-button--white sx-button--exit" mat-button (click)="onClose()">
      <svg>
        <use xlink:href="#baseline-close-24px" href="#baseline-close-24px" />
      </svg>
    </button>
    <div class="sx-help__header__title">
      {{ title }}
    </div>
  </div>

  <div class="sx-help__content">
    @if(!(isHelpLoading$ | async) && (currentHelpState$ | async) === helpStateEnum.contextualInfo && (helpData$ | async)){
      <div>
        <app-help-contextual-info 
          [contextualInfoData]="(helpData$  |async).contextualInfo" 
          [currentContextualInfoData]="(currentHelpContextualInfo$  |async)">
        </app-help-contextual-info>
      </div>
    }
    @if(!(isHelpLoading$ | async) && (currentHelpState$ | async) === helpStateEnum.glossary && (helpData$ | async)){
      <div>
        <app-help-glossary 
          [glossaryData]="(helpData$ | async).glossary" 
          [searchTerm]="(glossarySearchTerm$ | async)" 
          [searchTag]="(glossaryTagSearchTerm$ | async)">
        </app-help-glossary>
      </div>
    }
    @if(!(isHelpLoading$ | async) && !(areGuidesLoading$ | async) && (currentHelpState$ | async) === helpStateEnum.introduction && (helpData$ | async)){
      <div>
        <app-help-introduction [introductionData]="(helpData$ | async).introduction" [guides]="(guides$ | async)"></app-help-introduction>
      </div>
    }
    @if(!(isHelpLoading$ | async) && (currentHelpState$ | async) === helpStateEnum.support && (helpData$ | async)){
      <div>
        <app-help-support [supportData]="(helpData$ | async).support"></app-help-support>
      </div>
    }
    @if((isHelpLoading$|async) || ((currentHelpState$ | async) === helpStateEnum.introduction) && (areGuidesLoading$ | async)){
      <div>
        <app-spinner></app-spinner>
      </div>
    }
  </div>
</div>